import React from 'react';
import Slider from 'react-slick';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import { InView } from 'react-intersection-observer';
import * as actions from '../../../actions/productData';
import { fetchDeliveryDetails } from '../../../edd/actions';
import properties from '../../../modules/ajio-util/properties';

// import {onSelectionOfVariant} from "./eventLisiting";
import { generateEvent } from '../../../utils/dataGrinch';
import { getProductItemPDP, gtmEventPush, segmentEventPush, getSelectSizeSlaEventProps, getMultiSellerImageDetailsProps, getRushOptionSizesList } from '../../../modules/ga/GTMdatalayer';
import {
  getReturnCodCommunication,
  getDefaultPDPSkuSizeSelectionFlag,
  getMultiSellerSlaFlag
} from '../../../refresh/selectors/featureFlagsSelector';
import {
  getSlaOptionsForSku,
  getIsSlaFetching,
  getSlaError
} from '../../../refresh/molecules/DeliverySLA';

const sizeObj = {
  XXS: 'Double Extra Small',
  XS: 'Extra Small',
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large',
  XXL: 'Double Extra Large',
  'S/M': 'Small-Medium',
  'M/L': 'Medium-Large',
  'L/XL': 'Large-Extra Large'
};
class SizeVariant extends React.Component {
  constructor(props) {
    super(props);
    this.state = { sizeName: '', sizeStateFormat: '', toolTipMesg: '', activeTooltipIndex: null };
    this.onSelectSize = this.onSelectSize.bind(this);
    this.stocks = [];
    this.imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;
    this.initKeyboardRadioGroup = this.initKeyboardRadioGroup.bind(this);
    this.sliderInstanceRef = React.createRef();
    this.mutationObserver = null;
    // "Select Size Clicked" is deferred for the multiseller cohort until the
    // scopedView (v2) SLA data for the clicked SKU resolves (see onSelectSize /
    // componentDidUpdate). prevSlaLoading latches the load true->false edge.
    this.pendingSelectSizeEvent = null;
    this.prevSlaLoading = false;
    this.sizeWidgetViewedFired = false;
  }

  componentDidUpdate() {
    const pending = this.pendingSelectSizeEvent;
    const wasLoading = this.prevSlaLoading;
    this.prevSlaLoading = this.props.isSlaLoading;
    if (!this.props.enableMultiSellerSla || !pending || this.props.isSlaLoading || !wasLoading)
      return;
    const sla = getSelectSizeSlaEventProps(this.props.slaOptions);
    segmentEventPush({
      ...pending.base,
      pin_code: this.props.pincode,
      products: [{ ...getProductItemPDP(pending.product), ...sla.productProps }],
      seller_options: sla.sellerOptions
    });
    this.pendingSelectSizeEvent = null;
  }

  updateSlickArrowAria = () => {
  const container = document.getElementById('size-variant-block-id');
  if (!container) return;

  const arrows = container.querySelectorAll('.slick-arrow');

  arrows.forEach(btn => {
    const isDisabled = btn.classList.contains('slick-disabled');

    btn.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
    btn.setAttribute('tabindex', isDisabled ? '-1' : '0');
  });
};


  handleShow = (index) => {
    this.setState({ activeTooltipIndex: index });
  };

  handleHide = () => {
    this.setState({ activeTooltipIndex: null });
  };

  handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      this.setState({ activeTooltipIndex: null }); // close popover
    }
  };

  /**
   * Fire "Size Widget Viewed" once when the size block enters the viewport
   * (mirrors msite SizeSelectorPdp IntersectionObserver).
   */
  fireSizeWidgetViewed = () => {
    const { viewRender = '' } = this.props;
    if (viewRender === 'quickview' || this.sizeWidgetViewedFired) return;
    this.sizeWidgetViewedFired = true;

    const {
      sizeVariantData: sizeVariantOptions = [],
      oosStatus = [],
      productData,
      enableMultiSellerSla = false,
      sizeRecommendData = {},
      hasSizeChart = false,
      sizeFormat = '',
      brandSizeList = []
    } = this.props;

    const available = [];
    const oos = [];
    sizeVariantOptions.forEach(size => {
      const { code, stock = {}, variantOptionQualifiers = [], scDisplaySize = '' } = size || {};
      let sizeName = '';
      let sizeCheckFlag = false;
      (variantOptionQualifiers || []).forEach(q => {
        if (q?.qualifier === 'standardSize' && !sizeCheckFlag) {
          sizeName = q.value;
        } else if (q?.qualifier === 'size' && q.value) {
          sizeName = q.value;
          sizeCheckFlag = true;
        }
      });
      const label = scDisplaySize || sizeName;
      const isOos =
        oosStatus.includes(code) ||
        String(stock?.stockLevelStatus || '').toLowerCase() === 'outofstock';
      if (isOos) oos.push(label);
      else available.push(label);
    });

    const sizesForRush = available.concat(oos).map(value => ({ value }));
    const sizeDataMap = {};
    sizeVariantOptions.forEach(size => {
      let sizeName = '';
      let sizeCheckFlag = false;
      (size?.variantOptionQualifiers || []).forEach(q => {
        if (q?.qualifier === 'standardSize' && !sizeCheckFlag) sizeName = q.value;
        else if (q?.qualifier === 'size' && q.value) {
          sizeName = q.value;
          sizeCheckFlag = true;
        }
      });
      const key = size?.scDisplaySize || sizeName;
      if (key) sizeDataMap[key] = { code: size?.code };
    });

    segmentEventPush({
      event: 'Size Widget Viewed',
      available_sizes: available.length + oos.length,
      oos_sizes: oos.length,
      products: [
        {
          ...getProductItemPDP(productData),
          ...getMultiSellerImageDetailsProps(productData, enableMultiSellerSla),
          ...(enableMultiSellerSla && {
            rush_option_sizes: getRushOptionSizesList(
              sizesForRush,
              sizeDataMap,
              this.props.getDeliveryTypeData
            )
          })
        }
      ],
      recommended_size: sizeRecommendData?.sizeName || '',
      screen_name: 'pdp screen',
      size_chart_icon_available: Boolean(hasSizeChart),
      size_measurement_system: sizeFormat || '',
      size_measurement_type: brandSizeList?.length > 0 ? 'Brand' : 'Universal'
    });
  };

  onSizeWidgetInView = inView => {
    if (inView) this.fireSizeWidgetViewed();
  };

  componentDidMount() {
    let {
      sizeVariantData: size = [],
      viewRender = '',
      qualifierKey,
      appendDesc,
      selectSize
    } = this.props;
    if (viewRender !== 'quickview') {
      this.props.fetchStockList(this.stocks);
    }
    if (size.length === 1) {
      let {
        code,
        value,
        priceData = {},
        wasPriceData = {},
        variantOptionQualifiers = [],
        stock = {}
      } = size[0];
      let sizename = '';
      let unit = '';
      const { stockLevel: currentStockLevel, stockLevelStatus } = stock;
      if (appendDesc) {
        variantOptionQualifiers.forEach((element = {}) => {
          if (element.qualifier.toLowerCase() === qualifierKey.toLowerCase()) {
            sizename = element.value;
          }
          if (element.qualifier === 'uom' && element.value) {
            unit = element.value;
          }
        });
      }
      const sizeName = `${sizename} ${unit}`;
      const { displayformattedValue: discountPrice } = priceData;
      const { displayformattedValue: originalPrice } = wasPriceData;
      let stockLevel = { isLowStock: false, stockLevel: currentStockLevel };
      if (stockLevelStatus === 'lowStock') {
        stockLevel.isLowStock = true;
      }
      if (viewRender === 'quickview') {
        this.props.selectSizeQuickview(sizeName, code, stockLevel, discountPrice, originalPrice);
      } else {
        this.props.selectSize(sizeName, code, stockLevel, discountPrice, originalPrice, true);
        sessionStorage.setItem('defaultSKUSizeSelection', 'Auto-selected');
      }
    }
    const { sizeFormat = '' } = this.props;
    if (sizeFormat) {
      let sizeNameFF = this.manageSizeName(sizeFormat);
      this.setState({ sizeName: sizeNameFF, sizeStateFormat: sizeFormat });
    }
    const {
      sizeVariantData: sizeVariantOptions = [],
      optionCode = '',
      enableDefaultSizeSelection
    } = this.props;
    if (enableDefaultSizeSelection) {
      sizeVariantOptions.forEach(size_ => {
        const { stock = {}, priceData = {}, wasPriceData = {}, code, scDisplaySize } = size_;
        const { stockLevel } = stock;
        if (code === optionCode) {
          selectSize(
            scDisplaySize,
            optionCode,
            stockLevel,
            priceData.displayformattedValue,
            wasPriceData.displayformattedValue,
            true
          );
          sessionStorage.setItem('defaultSKUSizeSelection', 'Auto-selected');
        }
      });
    }
      this.updateSlickArrowAria();

  const container = document.getElementById('size-variant-block-id');
  if (!container) return;

  this.mutationObserver = new MutationObserver(this.updateSlickArrowAria);

  this.mutationObserver.observe(container, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
    this.initKeyboardRadioGroup('size-variant-block-id')
  }

  initKeyboardRadioGroup(groupId) {
    const group = document.getElementById(groupId);
    if (!group) return;

    const radios = Array.from(group.querySelectorAll('[role="radio"]'));

    this.setState({ colorSwatchRadioCount: radios.length });

    let atLeastOneChecked = false;

    // Set correct tabIndex on load
    radios.forEach((radio) => {
      const isChecked = radio.getAttribute('aria-checked') === 'true';
      radio.setAttribute('tabindex', isChecked ? '0' : '-1');

      if(isChecked){
        atLeastOneChecked = true;
      }
    });

    if(!atLeastOneChecked){
      radios[0].setAttribute('tabIndex','0');
    }

    function setFocus(radio) {
      radios.forEach(r => r.setAttribute('tabindex', r === radio ? '0' : '-1'));
      radio.focus();
    }

    function setChecked(radio) {
      radios.forEach(r => {
        const isSelected = r === radio;
        r.setAttribute('aria-checked', String(isSelected));
      });
    }

    group.addEventListener('keydown', function (e) {
      const active = document.activeElement;
      if (!radios.includes(active)) return;

      const currentIndex = radios.indexOf(active);
      let nextIndex = -1;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          e.preventDefault();
          nextIndex = (currentIndex + 1) % radios.length;
          setFocus(radios[nextIndex]);
          if (this.sliderInstanceRef?.current) {
            this.sliderInstanceRef.current.slickGoTo(nextIndex)
          }
          break;

        case 'ArrowLeft':
        case 'ArrowUp':
          e.preventDefault();
          nextIndex = (currentIndex - 1 + radios.length) % radios.length;
          setFocus(radios[nextIndex]);
          if (this.sliderInstanceRef?.current) {
            this.sliderInstanceRef.current.slickGoTo(nextIndex)
          }
          break;

        case ' ':
        case 'Spacebar': // legacy
        case 'Enter':
          e.preventDefault();

          // Set checked and simulate a real click to trigger navigation
          if (active.getAttribute('aria-disabled') !== 'false') {
            setChecked(active);
            active.click();
          }
          break;
      }
    });


  }

  handleClickEvent = (
    value,
    code,
    stockStatus,
    discountPrice,
    originalPrice,
    priceData,
    size,
    toolTipMesg
  ) => {
    this.onSelectSize(value, code, stockStatus, discountPrice, originalPrice, size, toolTipMesg);
    this.props.dodSizeSelection(size);
    this.props.handleGST(priceData);
  };

  manageSizeName = sizeName => {
    if (sizeObj[sizeName]) {
      return sizeObj[sizeName];
    }
    return 'Select Size';
  };

  onSelectSize(sizeName, sizeCode, stockLevel, discountPrice, originalPrice, size, toolTipMesg) {
    let { viewRender = '', newDesignLuxe, luxeEventPush } = this.props;
    if (viewRender === 'quickview') {
      this.props.selectSizeQuickview(sizeName, sizeCode, stockLevel, discountPrice, originalPrice);
      this.props.selectSizeErrorQuickview('');
    } else {
      this.props.selectSize(sizeName, sizeCode, stockLevel, discountPrice, originalPrice, true);
      sessionStorage.setItem('defaultSKUSizeSelection', 'Mannual');
      this.props.selectSizeError('');
      // this.props.fetchDeliveryDetails();
      if(this.props.returnCodCommunication?.isPdpEnabled){
        this.props.fetchProductServiceability();
      }
    }
    let sizeNameFF = this.manageSizeName(sizeName);
    if (sizeNameFF !== 'Select Size') {
      this.setState({ sizeName: sizeNameFF, sizeStateFormat: sizeName, toolTipMesg });
    } else {
      this.setState({ sizeName: sizeNameFF, toolTipMesg });
    }

    // Deal Changes on size Selection
    this.props.dodSizeSelection(size);
    // let isDodItemOutOfStock =  _get(size, 'priceData.deal.isSoldOut') || false;
    // isDodItemOutOfStock === false && this.props._handleDealStockOverOnSizeClick();
    this.props._handleDealStockOverOnSizeClick();
    // if(isDodItemOutOfStock){
    //   this.props.showModal('deal-out-of-stock');
    // }
    if (!newDesignLuxe) {
      gtmEventPush({
        event: 'product_size_change',
        event_category: 'product details interactions',
        event_action: 'size change',
        page_type: 'pdp screen',
        event_label: sizeName,
        product_size: sizeName
      });
    } else {
      luxeEventPush({
        eventName: 'product_size_change',
        event_action: 'size change',
        page_type: 'pdp screen',
        event_label: sizeName
      });
    }
    if (!newDesignLuxe && toolTipMesg) {
      const { brandName = '', name = '', code } = this.props;
        gtmEventPush({
          page_type: 'pdp screen',
          event: 'product_details_interactions',
          category: 'product details interactions',
          action: 'Tool tip impression',
          label: 'visible',
          product_id: code,
          Product_size: sizeName,
          product_name: name,
          product_brand: brandName
        });
      }
      const selectSizeClickedBasePayload = {
        event: 'Select Size Clicked',
        half_card_or_pdp : 'PDP',
        //hit_number
        page_source : 'PDP Page',
        screen_name : 'Size Variant',
        selected_size_actual: sizeName,
        selected_size_brand: this.props?.brandName,
        selected_size_brand_size_chart: '',
        selected_size_universal: '',
        selected_size_universal_size_chart:'',
        size_measurement_type : '',
        tool_tip_content : toolTipMesg,
        urgency_text : ''
      };
      const selectSizeClickedProduct = { ...size, ...this.props };
      if (this.props.enableMultiSellerSla) {
        // Defer until scopedView (v2) resolves so seller_options / price_group_id
        // are populated; componentDidUpdate fires once SLA data for this SKU lands.
        this.pendingSelectSizeEvent = {
          base: selectSizeClickedBasePayload,
          product: selectSizeClickedProduct
        };
      } else {
        segmentEventPush({
          ...selectSizeClickedBasePayload,
          products: [{ ...getProductItemPDP(selectSizeClickedProduct) }]
        });
      }

  }

  hideTableColumn = (flag = false, s_value = '') => {
    if (!flag) {
      // flag === OFF
      if (
        s_value.toLowerCase().indexOf('universal size format') === -1 &&
        s_value.toLowerCase().indexOf('brand size format') === -1 &&
        s_value.toLowerCase().indexOf('universal size') === -1
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      // flag === ON
      return true;
    }
  };

  hideColumnInToolTip = (s_value = '') => {
    if (
      s_value.toLowerCase().indexOf('universal size format') === -1 &&
      s_value.toLowerCase().indexOf('brand size format') === -1 &&
      s_value.toLowerCase().indexOf('brand size') === -1 &&
      s_value.toLowerCase().indexOf('universal size') === -1
    ) {
      return true;
    } else {
      return false;
    }
  };

  checkIfSizeOverflow = () => {
    let container = document.getElementsByClassName('size-variant-block');

    if (container[0] && container[0].scrollHeight > 121) {
      return true;
    }
  };

  componentWillUnmount() {
  if (this.mutationObserver) {
    this.mutationObserver.disconnect();
    this.mutationObserver = null;
  }
}

  render() {
    let {
      sizeVariantData: sizeVariantOptions = [],
      sizeToolTip = [],
      oosStatus = [],
      appendDesc,
      hideSizes,
      qualifierKey,
      newDesignLuxe
    } = this.props;
    let {
      productSizeCode,
      quickviewSizeCode,
      currentProductCode = '',
      brandName = '',
      name = ''
    } = this.props;
    let { viewRender = '', newFeatureFlag = false } = this.props;
    const self = this;
    let arrTooltip = [];
    let sizeSwatchVariant;
    let sizeVariant;
    let sizeName;
    let showBrandTextValue = '';
    let sizeStyle = 'circle';
    let arr = [];
    let selectedSize = '';
    let stocks = [];
    let sizeCheckFlag = false;
    if (viewRender == 'quickview') {
      selectedSize = quickviewSizeCode;
    } else {
      selectedSize = productSizeCode;
    }
    if (currentProductCode && !productSizeCode) {
      selectedSize = currentProductCode;
    }
    let unit = '';
    const filterBySize = size => {
      if (size.qualifier === 'standardSize' && !sizeCheckFlag) {
        sizeName = size.value;
        showBrandTextValue = size.value;
      } else {
        if (size.qualifier === 'size' && size.value) {
          sizeName = size.value;
          sizeCheckFlag = true;
        }
      }
      // case when only volume/weight is there no sizes so show volume in description
      if (appendDesc) {
        if (size.qualifier.toLowerCase() === qualifierKey.toLowerCase() && size.value) {
          sizeName = size.value;
        }
        if (size.qualifier === 'uom' && size.value) {
          unit = size.value;
        }
      }
    };
    sizeVariantOptions.forEach((size, i) => {
      const {
        stock = {},
        variantOptionQualifiers = [],
        priceData = {},
        wasPriceData = {},
        code,
        scDisplaySize = ''
      } = size;
      let { stockLevelStatus, stockLevel } = stock;
      sizeCheckFlag = false;
      const filteredSize = variantOptionQualifiers.filter(filterBySize);
      stockLevelStatus = oosStatus.includes(code) ? 'outOfStock' : stockLevelStatus;
      let value = sizeName;
      if (newFeatureFlag) {
        value = scDisplaySize || sizeName;
      }
      if (appendDesc) {
        value = `${sizeName} ${unit}`;
      }
      arr.push({
        code: size.code,
        stockLevelStatus,
        stockLevel,
        // value: scDisplaySize ? scDisplaySize : sizeName,
        value,
        toolTipSize: sizeName,
        showBrandTextValue,
        discountPrice: priceData.displayformattedValue,
        originalPrice: wasPriceData.displayformattedValue,
        priceData,
        wasPriceData,
        sizeAriaLabel: this.manageSizeName(sizeName)
      });
    });

    this.stocks = arr;

    if (sizeToolTip) {
      sizeToolTip.forEach((sizeDataObj, index) => {
        let attrCounter = 0;
        let prodDesc = '';
        let spDesc = '';
        let tooltipHeading = '';
        let tooltipFlag = false;
        let unitAttr = '"';
        let noOfAtrrToShow = 2;

        if (
          !'Show_Tool_Tip' in sizeDataObj ||
          ('Show_Tool_Tip' in sizeDataObj &&
            sizeDataObj.Show_Tool_Tip.toUpperCase() != 'NO' &&
            sizeDataObj.Show_Tool_Tip != '0')
        ) {
          Object.keys(sizeDataObj).forEach(function(s_value, index) {
            if ('Show_Tool_Tip' in sizeDataObj && sizeDataObj.Show_Tool_Tip.toUpperCase() != 'NO') {
              let { Show_Tool_Tip } = sizeDataObj;
              noOfAtrrToShow = Show_Tool_Tip;
            }
            if ('MEASUREMENT_UNIT' in sizeDataObj) {
              if (sizeDataObj.MEASUREMENT_UNIT == 0) {
                unitAttr = '';
              } else if (sizeDataObj.MEASUREMENT_UNIT == 1) {
                unitAttr = ' cm';
              }
            }
            if (
              s_value.toUpperCase().indexOf('_ATTRIBUTE') >= 0 &&
              attrCounter < noOfAtrrToShow &&
              self.hideColumnInToolTip(s_value)
            ) {
              attrCounter++;
              prodDesc = prodDesc.concat(
                `${s_value.split('_')[0]}-${sizeDataObj[s_value]}${unitAttr}  |  `
              );
            }
            if (s_value.toUpperCase() == 'DESCRIPTION') {
              spDesc = sizeDataObj[s_value].toLowerCase();
            }
            if (s_value.toUpperCase() == 'TOOLTIP_TITLE') {
              tooltipFlag = true;
              tooltipHeading = sizeDataObj[s_value];
            } else if (s_value.toUpperCase() == 'MEASUREMENT_TYPE' && tooltipFlag == false) {
              tooltipHeading = sizeDataObj[s_value];
            }
          });
          prodDesc = prodDesc.substring(0, prodDesc.lastIndexOf('|'));
          arrTooltip.push({
            id: index,
            prodDesc,
            tooltipHeading,
            spDesc,
            sizeName: sizeDataObj.SIZE_NAME
          });
        }
      });
    }
    if (arr.length) {
      arr.forEach(size => {
        const { value } = size;
        if (value.length >= 4) {
          sizeStyle = 'oval';
        }
      });
      sizeVariant = arr.map((size, i) => {
        let selectedSizeCode = '';
        let {
          value,
          code,
          stockLevelStatus,
          stockLevel,
          discountPrice,
          originalPrice,
          priceData,
          toolTipSize,
          sizeAriaLabel
        } = size;
        let filteredTooltip =
          arrTooltip.filter(function(toolTipItem) {
            return toolTipItem.sizeName == value;
          })[0] || {};
        let stockStatus = { isLowStock: false, stockLevel, stockLevelStatus };
        if (stockLevelStatus === 'lowStock') {
          stockStatus.isLowStock = true;
        }
        if (code === selectedSize) {
          selectedSizeCode = 'selected';
        }
        return (
          <div 
            key={i} 
            className="size-swatch"
          >
            {stockLevelStatus !== 'outOfStock' && filteredTooltip.sizeName !== undefined && (
              <OverlayTrigger
              //required for clsoing the tooltip on esc key as per accessibility requirement
                show={this.state.activeTooltipIndex === i}
                placement="top"
                id={i}
                overlay={
                  <Popover
                    id={`tooltip-${i}`}
                    bsPrefix={newDesignLuxe ? 'fade show popover bs-popover-top luxe-tooltip' : ''}
                  >
                    <Popover.Body>
                      <div className="size-tooltip">
                        <div className="tooltip-heading">
                          {filteredTooltip.tooltipHeading} ({value})
                        </div>
                        <div className="tooltip-description">{filteredTooltip.prodDesc}</div>
                        {newDesignLuxe && (
                          <div className="tooltip-info">{filteredTooltip.spDesc}</div>
                        )}
                      </div>
                    </Popover.Body>
                  </Popover>
                }
              >
                <div
                  className={`${sizeStyle} size-variant-item size-instock ${selectedSizeCode}`}
                  role="radio"
                  aria-checked={selectedSizeCode.toLowerCase() === 'selected'}
                  tabIndex={0}
                  onClick={() =>
                    this.onSelectSize(
                      value,
                      code,
                      stockStatus,
                      discountPrice,
                      originalPrice,
                      size,
                      filteredTooltip.spDesc ?? ''
                    )
                  }
                  onFocus={() => this.handleShow(i)}
                  onBlur={this.handleHide}
                  onMouseEnter={() => this.handleShow(i)}
                  onMouseLeave={this.handleHide}
                  onKeyDown={this.handleKeyDown}
                >
                  {' '}
                  {newDesignLuxe ? (
                    <>
                      <div className="sizeval" aria-label={this.manageSizeName(value)}>{value}</div>
                      {stockLevel < 10 && <div className="stockleftsize">{stockLevel} left</div>}
                    </>
                  ) : (
                    <span aria-label={this.manageSizeName(value)}>{value}</span>
                  )}{' '}
                </div>
              </OverlayTrigger>
            )}
            {stockLevelStatus !== 'outOfStock' && filteredTooltip.sizeName === undefined && (
              <div
                className={`${sizeStyle} size-variant-item size-instock ${selectedSizeCode}`}
                onClick={() =>
                  this.handleClickEvent(
                    value,
                    code,
                    stockStatus,
                    discountPrice,
                    originalPrice,
                    priceData,
                    size,
                    filteredTooltip.spDesc ?? ''
                  )
                }
                role="radio"
                aria-checked={selectedSizeCode === 'selected' ? "true" : "false"}
                // tabIndex={0}
              >
                {newDesignLuxe ? (
                  <>
                    <div className="sizeval">{value}</div>
                    {stockLevel < 10 && <div className="stockleftsize">{stockLevel} left</div>}
                  </>
                ) : (
                    <span aria-label={sizeAriaLabel !== "Select Size" ? sizeAriaLabel : this.manageSizeName(value)}>{value}</span>
                )}
              </div>
            )}
            {stockLevelStatus === 'outOfStock' && newDesignLuxe ? (
              <div 
                className={`${sizeStyle} size-variant-item size-outstock`} 
                role="radio"
                aria-checked={selectedSizeCode === 'selected' ? "true" : "false"}
                // tabIndex={0}
                aria-disabled="true"
              >
                <div className="sizeval" aria-label={this.manageSizeName(value)}>{value}</div>
              </div>
            ) : (
              stockLevelStatus === 'outOfStock' && (
                <div 
                  className={`${sizeStyle} swatch-size-oos size-variant-item sprite-img`}
                  role="radio"
                  aria-checked={selectedSizeCode === 'selected' ? "true" : "false"}
                  // tabIndex={0}
                  aria-disabled="true"
                  aria-label={this.manageSizeName(value)}
                >
                  {value}
                </div>
              )
            )}
          </div>
        );
        // }
      });
    }
    var sts;
    var str;
    if (newDesignLuxe) {
      sts = 5;
      str = 1;
    } else {
      sts = 5;
      str = 1;
    }
    let slickSettings = {
      dots: false,
      infinite: false,
      slidesToShow: sts,
      slidesToScroll: str,
      arrows: true,
      autoplay: false,
      className: 'size-swatch-slick'
    };
    if (sizeStyle === 'oval' && !newDesignLuxe) {
      slickSettings = {
        dots: false,
        infinite: false,
        slidesToShow: 2.5,
        slidesToScroll: 2.5,
        arrows: true,
        autoplay: false,
        className: 'size-swatch-slick oval'
      };
    }

    if (sizeVariantOptions.length > 5 || (sizeStyle === 'oval' && sizeVariantOptions.length > 2)) {
      if (sizeStyle === 'oval' && !newDesignLuxe) {
        sizeSwatchVariant = (
          <Slider {...slickSettings} ref={this.sliderInstanceRef}>
            {sizeVariant}
          </Slider>
        );
      } else {
        sizeSwatchVariant = sizeVariant;
      }
    } else {
      sizeSwatchVariant = sizeVariant;
    }

    if (sizeVariantOptions.length > 5 || this.checkIfSizeOverflow()) {
      sizeSwatchVariant = (
        <Slider {...slickSettings} ref={this.sliderInstanceRef}>
          {sizeVariant}
        </Slider>
      );
    } else {
      sizeSwatchVariant = sizeVariant;
    }

    const { sizeStateFormat = '', sizeName: stateSizeName = '', toolTipMesg = '' } = this.state;
    const { sizeFormat = '' } = this.props;
    let displaySizeFormat = '';
    if (sizeStateFormat) {
      displaySizeFormat = sizeStateFormat;
    } else {
      displaySizeFormat = sizeFormat;
    }
    const displaySize = displaySizeFormat ? (
      <span className="size-format" aria-label={displaySizeFormat}>({displaySizeFormat})</span>
    ) : (
      ''
    );
    const displaySizeName = arr.length >= 1 && (
      <div className="size-selection" id="selectSizeId" aria-label={`${stateSizeName ? stateSizeName : 'Select Size'}`}>
        {' '}
        {stateSizeName || 'Select Size'} {displaySize}
      </div>
    );
    const displayToolTipMesg = toolTipMesg.length > 0 && !newDesignLuxe && (
      <div className="tooltip-container">
        <img className="imageIcon" src={`${this.imageBaseRef}tooltip_bulb.svg`} alt="Tip icon" />
        <p className="size-tooltip-mesg" aria-label={toolTipMesg}>{toolTipMesg}</p>
      </div>
    );
    if (hideSizes) {
      return null;
    }
    const sizeBlock = (
      <div className="size-variant-block" role="radiogroup" aria-labelledby='selectSizeId' id='size-variant-block-id'>
        {displaySizeName}
        {displayToolTipMesg}
        {sizeSwatchVariant}
        {/* { viewRender === "quickview" && quickviewSizeStockLevel && <div className="prod-stock-status">Only {quickviewSizeStockLevel} left in stock</div> } */}
      </div>
    );
    // Quickview skips the visibility event — PDP only, same as msite dataFrom === 'pdp'.
    if (viewRender === 'quickview') {
      return sizeBlock;
    }
    return (
      <InView threshold={0.5} triggerOnce onChange={this.onSizeWidgetInView}>
        {sizeBlock}
      </InView>
    );
  }
}

const mapStateToProps = state => {
  const { product = {}, popup = {}, flags } = state;
  let { selectedSizeCode: productSizeCode = '', productDetails = {} } = product;
  let { selectedSizeCode: quickviewSizeCode = '' } = popup;
  const {
    name = '',
    code = ''
  } = productDetails;
  const optionCode = productDetails?.request?.optionCode;
  const pincode = state?.edd?.activePincode;
  const skuId = productSizeCode;
  return {
    productSizeCode,
    quickviewSizeCode,
    name,
    code,
    returnCodCommunication: getReturnCodCommunication(state),
    optionCode,
    enableDefaultSizeSelection: getDefaultPDPSkuSizeSelectionFlag(flags),
    enableMultiSellerSla: getMultiSellerSlaFlag(state),
    pincode,
    slaOptions: getSlaOptionsForSku(state, pincode, skuId),
    isSlaLoading: getIsSlaFetching(state, pincode, skuId),
    slaError: getSlaError(state, pincode, skuId)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectSize: (sizeName, sizeCode, stockLevel, discountPrice, originalPrice, cartOrNot) => {
      generateEvent({
        Event: 'SizeSelection',
        value: {
          SizeSelectionValue: sizeName
        }
      });
      dispatch(
        actions.selectSize(sizeName, sizeCode, stockLevel, discountPrice, originalPrice, cartOrNot)
      );
    },
    dodSizeSelection: size => dispatch(actions.dodSizeSelection(size)),
    selectSizeError: message => dispatch(actions.selectSizeError(message)),
    selectSizeQuickview: (sizeName, sizeCode, stockLevel, discountPrice, originalPrice) =>
      dispatch(
        actions.selectSizeQuickview(sizeName, sizeCode, stockLevel, discountPrice, originalPrice)
      ),
    selectSizeErrorQuickview: message => dispatch(actions.selectSizeErrorQuickview(message)),
    fetchDeliveryDetails: pincode => dispatch(fetchDeliveryDetails(pincode)),
    fetchProductServiceability: (...args) =>{
      import(/* webpackChunkName: "static/chunk/actions" */ '../../../refresh/pages/ProductPage/actions')
        .then(module => {
          const { fetchProductServiceability } = module;
          dispatch(fetchProductServiceability(...args)); // new serviceability api
        })
        .catch(error => console.log('err', error));
    },
  };
};

export default SizeVariant = connect(mapStateToProps, mapDispatchToProps)(SizeVariant);
